export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7344.ce0c3e1c.jpg";